<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<p class="ded"><em class="italic">For Linda,<br/>don’t let us look back,<br/>but onwards, arm in arm</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?72751319